/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tidy_Close_Gopher_DelightInputs */

const fr_tidy_close_gopher_delight = /** @type {(inputs: Tidy_Close_Gopher_DelightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permissions`)
};

/**

* @param {Tidy_Close_Gopher_DelightInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const tidy_close_gopher_delight = /** @type {((inputs?: Tidy_Close_Gopher_DelightInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tidy_Close_Gopher_DelightInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_tidy_close_gopher_delight(inputs)
});